<template>
    <div id="ModalTwoFactoryGoogle" class="modal fade in" data-backdrop="static" data-keyboard="false" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content">
                <!-- Modal content-->
                <div class="modal-header">
                    <p class="modal-title"><i class="fa fa-google"></i> Google Authenticator</p>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p>{{loginMsg}}</p>
                    <div class="form-group">
                        <required /> <label> Código</label>
                        <input name="token" v-mask="'######'"
                            placeholder="Insira o código do aplicativo Google Authenticator" class="form-control form-control-lg"
                            v-model="request.token_otp" :class="{ 'is-invalid': errors.has('token') }">
                        <div class="invalid-feedback help-block error">{{errors.first('token')}}</div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" data-dismiss="modal" class="btn btn-default float-left">
                        <i class="fa fa-times"></i> {{$t('words.cancel')}}
                    </button>
                    <button type="button" @click="confirm()" :disabled="loading" class="btn btn-success"><i
                            class="fa fa-check"></i> {{$t('words.access')}}
                        <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            request: {}
        },
        data() {
            return {
                loginMsg: '',
                loading: false,
            }
        },
        watch: {
            'request.token_otp' (data) {
                if (data.length == 6) {
                    this.confirm();
                }
            }
        },
        methods: {
            show(response) {
                this.loginMsg = response.data.message;
                $('#ModalTwoFactoryGoogle').modal('toggle');
            },
            confirm() {
                if (this.request.companyId) {
                    this.logar();
                } else {
                    this.login();
                }
            },
            logar() {
                this.loading = true;
                this.$auth.logar(this.request)
                    .then(response => {
                         console.log(response);
                        $('#ModalTwoFactoryGoogle').modal('toggle');
                         window.location.href="/dashboard";
                    }).catch(error => {
                        toastr({
                            icon: error.data.status,
                            title: error.data.message
                        });
                    }).finally(() => {
                        this.loading = false;
                    });
            },
            login() {
                this.loading = true;
                this.$auth.login(this.request)
                    .then(response => {
                        console.log(response);
                        $('#ModalTwoFactoryGoogle').modal('toggle');
                         window.location.href="/dashboard";
                    }).catch(error => {
                        toastr({
                            icon: error.data.status,
                            title: error.data.message
                        });
                    }).finally(() => {
                        this.loading = false;
                    });
            }
        }
    }
</script>